const updateArray = (data, link) => {
  const copyData = JSON.parse(JSON.stringify(data));
  let Index = copyData.findIndex((v) => v.link === link);
  copyData.map((v, i) => (copyData[i].active = false));
  if (Index > -1) {
    copyData[Index].active = true;
  }
  return { copyData };
};

export default updateArray;
